import { PropsWithChildren } from 'react';

import { Box, Row, Text } from '@opendoor/bricks-next';
import { Avatar } from 'components/shared/Avatar';

import { IAuthor, IEditor, IReviewer } from '../../declarations/contentful';

// Person component, with a place for extra text (i.e. passed in as children)
export const PersonInline: React.FC<
  PropsWithChildren<{ person?: IAuthor | IEditor | IReviewer }>
> = (props) => {
  if (!props.person) {
    return null;
  }
  const {
    firstName = '',
    lastName = '',
    picture = '',
    credential,
    displayName,
  } = props.person.fields;
  const initials = firstName.charAt(0) + lastName.charAt(0);
  return (
    <Row key={firstName + lastName} alignSelf="flex-start" alignItems="center">
      {picture && (
        <Box display="none" $largerThanMD={{ display: 'block' }}>
          <Avatar size="lg" src={picture} initials={initials} alt={displayName} />
        </Box>
      )}
      <Box display="block" $largerThanMD={{ ml: picture ? '$6x' : 0 }}>
        <Text tag="p" typography="$labelMedium" $platform-web={{ fontWeight: 600 }} mb={0} mt={0}>
          {displayName}
          {credential && (
            <>
              <Text tag="span" typography="$labelMedium" $platform-web={{ fontWeight: 600 }}>
                ,&nbsp;
              </Text>
              <Text tag="span" typography="$bodyMedium">
                {credential}
              </Text>
            </>
          )}
        </Text>
        {props.children}
      </Box>
    </Row>
  );
};
